import styled from 'styled-components';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const PaddingDesktopDiv = styled.div`
  padding: ${p => p.theme.unit(8)} 0;
`;

const PaddingMobileDiv = styled.div`
  padding: ${p => p.theme.unit(5)} 0;
`;

const TopBottomPadding = (props) => {
  const {
    children,
  } = props;

  const DesktopBody = (
    <PaddingDesktopDiv>
      {children}
    </PaddingDesktopDiv>
  );

  const MobileBody = (
    <PaddingMobileDiv>
      {children}
    </PaddingMobileDiv>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody}
      mobileChildren={MobileBody} />);

  return renderComp;
};

export default TopBottomPadding;
